// Vendors
import { Navigate, Outlet } from 'react-router-dom';

type OktaTokenStorage = {
  accessToken?: {
    accessToken?: string;
  };
};

const ProtectedRoute = () => {
  const oktaTokenStorage = localStorage.getItem('okta-token-storage');
  let accessToken = null;
  if (oktaTokenStorage) {
    let oktaToken: OktaTokenStorage = JSON.parse(oktaTokenStorage) as OktaTokenStorage;
    if (oktaToken.accessToken) {
      accessToken = oktaToken.accessToken.accessToken;
    }
  }

  return accessToken ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
